import React, { Component, useEffect, useState } from 'react';
import '../app/App.css';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { setLocalStore, getLocalStore, convertXxtea, renderDate, renderStrDate } from '../helpers/helper';
import * as config from '../../config/config';
import { useNavigate } from 'react-router-dom';
import { Toaster, toast } from 'react-hot-toast';
import GridLoader from "react-spinners/GridLoader";


export default function Detail() {

    const [dataJob, setDataJob] = useState([]);
    const [statusClass, setStatusClass] = useState('title-info');
    const [statusDesc, setStatusDesc] = useState('');
    const [dueDate, setDueDate] = useState('');
    const [createDate, setCreateDate] = useState('');
    const [listAssignedPerson, setListAssignedPerson] = useState('');
    const [countMember, setCountMember] = useState(0);
    const [countDone, setCountDone] = useState(0);
    const [creator, setCreator] = useState([]);
    const [displayModal, setDisplayModal] = useState('none');
    const [isHost, setIsHost] = useState(0);
    const [displayComplete, setDisplayComplete] = useState('none');
    const [displayClose, setDisplayClose] = useState('none');
    const [displayAccept, setDisplayAccept] = useState('none');
    const [displayRefuse, setDisplayRefuse] = useState('none');
    const [displayDiscuss, setDisplayDiscuss] = useState('none');
    const [displayEdit, setDisplayEdit] = useState('none');
    const [displayReopen, setDisplayReopen] = useState('none');
    const [displayDelete, setDisplayDelete] = useState('none');
    const [displayRemind, setDisplayRemind] = useState('none');
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const queryParams = new URLSearchParams(window.location.search);
    const mcapp = queryParams.get('mcapp');

    var uuidParams = queryParams.get('uuid');
    var host = queryParams.get('host');
    if (uuidParams !== null) {
        setLocalStore('uuid', uuidParams);
    } else {
        uuidParams = getLocalStore('uuid');
    }

    if (host !== null) {
        setLocalStore('host', host);
    } else {
        host = getLocalStore('host');
        // host = 'a';
    }

    const jobId = queryParams.get('id');
    const navigate = useNavigate();


    useEffect(() => {
        getDataJob();
    }, []);


    function getDataJob() {
        setLoading(true);
        let dataJobDetail = {
            msisdn: uuidParams,
            jobId: jobId,
        };
        console.log(dataJobDetail);
        let encrypt_data = convertXxtea(dataJobDetail);
        let dataRequest = {
            msisdn: uuidParams,
            host: host,
            data: encrypt_data,
            clientType: 'web',
            revision: 'a',
            languageCode: 'vi',
            countryCode: 'VN',
            timestamp: new Date().getTime(),
            security: 'a',
        };
        axios({
            method: 'POST',
            url: config.DOMAIN_API_JOB_ASSIGN + 'job_details',
            data: dataRequest,
            headers: { 'content-type': 'multipart/form-data' }
        }).then(({ data }) => {
            console.log(data);
            setLoading(false);
            if (data.code === 200) {
                setShow(true);
                setDataJob(data.data);
                makeStatus(data.data);
                formatDateInfo(data.data.jobDueDate);
                setListAssignedPerson(data.data.listAssignedPerson);
                setCountMember(data.data.listAssignedPerson.length);
                setCreator(data.data.creatorInfo.name);
                if (data.data.creatorInfo.uuid === uuidParams) {
                    setIsHost(1);
                    renderButtonModal(data.data, 1);
                } else {
                    setIsHost(0);
                    renderButtonModal(data.data, 0);
                }
                setCountDone(data.data.listDoneJob.length);
            } else {
                console.log(data.code);
            }
        }).catch(function (result) {
            setLoading(false);
            console.log(result);
        });
    }

    function formatDateInfo(d) {
        let dn = new Date(d);
        setDueDate(renderDate(dn));
    }

    function renderDateInfo(d) {
        let dn = new Date(d);
        let str = renderStrDate(dn);
        console.log(str);
        return (
            <>
                {str}
            </>
        );
    }

    function makeStatus(data) {
        switch (data.jobState) {
            case 0:
                // setStatusDesc('Chưa nhận ' + '(' + data.totalWaitingJob +')');
                setStatusDesc('Chưa nhận');
                setStatusClass('title-info');
                break;
            case 1:
                setStatusDesc('Đã hoàn thành ' + '(' + data.totalDoneJob + ')');
                setStatusClass('title-success');
                break;
            case 2:
                setStatusDesc('Quá hạn ' + '(' + data.totalOverdueJob + ')');
                setStatusClass('title-out-of-date');
                break;
            case 3:
                setStatusDesc('Đang thực hiện ' + '(' + data.totalReceivedJob + ')');
                setStatusClass('title-info');
                break;
            default:
        }



        // if (data.isExpired === 1) {
        //     setStatusDesc('Quá hạn');
        //     setStatusClass('title-out-of-date');
        // } else {
        //     if (data.jobStatus === 0) {
        //         setStatusDesc('Chưa nhận việc');
        //         setStatusClass('title-info');
        //     } else {
        //         if (data.jobActive === 0) {
        //             setStatusDesc('Đang thực hiện');
        //             setStatusClass('title-info');

        //         } else {
        //             setStatusDesc('Đã hoàn thành');
        //             setStatusClass('title-success');
        //         }
        //     }
        // }
    }

    function openDetailAnDiscuss(id, title, type, ref) {
        let link = 'vconnect://assignwork?type=' + type + '&ref=' + encodeURIComponent(config.DOMAIN + 'detail?id=' + id) + '&title=' + encodeURIComponent(title);
        window.open(link);
    }

    function submitJobs(action, jobID) {
        setLoading(true);
        console.log(action, jobID);
        let dataJob = {
            action: action,
            phone: uuidParams,
            jobAssignedId: jobID
        };
        console.log(dataJob);
        let encrypt_data = convertXxtea(dataJob);
        let dataSubmit = {
            msisdn: uuidParams,
            host: host,
            data: encrypt_data,
            clientType: 'web',
            revision: 'a',
            languageCode: 'vi',
            countryCode: 'VN',
            timestamp: new Date().getTime(),
            security: 'a',
        };

        axios({
            method: 'POST',
            url: config.DOMAIN_API_JOB_ASSIGN + 'submit_job',
            data: dataSubmit,
            headers: { 'content-type': 'multipart/form-data' }
        }).then(({ data }) => {
            console.log(data);
            setLoading(false);
            if (data.code === 200) {
                console.log(action + 'success');
                switch (action) {
                    case 'remindJob':
                        toast.success('Đã gửi lời nhắc nhở');
                        break;
                    case 'doneJob':
                        toast.success('Đã hoàn thành công việc');
                        break;
                    case 'closeJob':
                        toast.success('Đóng việc thành công');
                        break;
                    case 'deleteJob':
                        if (isHost === 1) {
                            toast.success('Xóa việc thành công');
                        } else {
                            toast.success('Đã từ chối công việc');
                        }
                        break;
                    case 'recipientJob':
                        toast.success('Nhận việc thành công');
                        break;
                    case 'reopenJob':
                        toast.success('Mở lại việc thành công');
                        break;
                    default:
                        toast.success('Success')
                }

            } else {
                console.log(action + 'error');
                switch (action) {
                    case 'remindJob':
                        toast.error('Nhắc nhở không thành công');
                        break;
                    case 'doneJob':
                        toast.error('Hoàn thành công việc chưa thành công');
                        break;
                    case 'closeJob':
                        toast.error('Đóng việc không thành công');
                        break;
                    case 'deleteJob':
                        if (isHost === 1) {
                            toast.error('Xóa việc không thành công');
                        } else {
                            toast.error('Từ chối công việc không thành công');
                        }
                        break;
                    case 'recipientJob':
                        toast.error('Nhận việc không thành công');
                        break;
                    case 'reopenJob':
                        toast.error('Mở lại việc không thành công');
                        break;
                    default:
                        toast.error('Error')
                }
            }

            closeModal();
        }).catch(function (result) {
            setLoading(false);
            console.log(result);
        });

        setTimeout(() => {
            getDataJob();
        }, 1000);
    }

    function renderBackBtn() {

        if (mcapp !== null) {
            console.log(mcapp);
            return (
                <>
                    <button onClick={() => closeDetail()}>
                        <img src="../../images/icon/back-btn.png" alt="" />
                    </button>
                </>
            );
        } else {
            return (
                <>
                    <button onClick={() => navigate(-1)}>
                        <img src="../../images/icon/back-btn.png" alt="" />
                    </button>
                </>
            );
        }
    }

    function renderButton(data) {
        if (isHost === 0) {

            if (data.jobPersonStatus === 1) {
                return (
                    <>
                        <div className="btn-left">
                            <button onClick={() => openDetailAnDiscuss(data.jobAssignId, data.jobTitle, 'discuss', 'discuss')}>Thảo luận</button>
                        </div>
                    </>
                );
            } else {
                if (data.isExpired === 1) {
                    return (
                        <>
                            <div className="btn-left">
                                <button onClick={() => openDetailAnDiscuss(data.jobAssignId, data.jobTitle, 'discuss', 'discuss')}>Thảo luận</button>
                            </div>
                            <div className="btn-right">
                                <button onClick={() => submitJobs('doneJob', data.jobAssignId)}>Hoàn thành</button>
                            </div>
                        </>
                    );
                } else {
                    if (data.jobPersonRecipientStatus === 0) {
                        return (
                            <>
                                <div className="btn-left">
                                    <button onClick={() => submitJobs('deleteJob', data.jobAssignId)}>Từ chối việc</button>
                                </div>
                                <div className="btn-right">
                                    <button onClick={() => submitJobs('recipientJob', data.jobAssignId)}>Nhận thực hiện</button>
                                </div>
                            </>
                        );
                    } else {
                        return (
                            <>
                                <div className="btn-left">
                                    <button onClick={() => openDetailAnDiscuss(data.jobAssignId, data.jobTitle, 'discuss', 'discuss')}>Thảo luận</button>
                                </div>
                                <div className="btn-right">
                                    <button onClick={() => submitJobs('doneJob', data.jobAssignId)}>Hoàn thành</button>
                                </div>
                            </>
                        );
                    }
                }
            }
        } else {
            if (data.jobActive === 1) {
                return (
                    <>
                        <div className="btn-left">
                            <button onClick={() => submitJobs('reopenJob', data.jobAssignId)}>Mở lại</button>
                        </div>
                        <div className="btn-right">
                            <button onClick={() => window.location.assign('vconnect://assignwork?type=create')}>Tạo việc</button>
                        </div>
                    </>
                );
            } else if (data.isExpired === 1) {
                return (
                    <>
                        <div className="btn-left">
                            <button onClick={(e) => { submitJobs('closeJob', data.jobAssignId); handleHide(e) }}>Đóng việc</button>
                        </div>
                        <div className="btn-right">
                            <button onClick={(e) => { submitJobs('remindJob', dataJob.jobAssignId); handleClick(e) }}>Nhắc nhở</button>
                        </div>
                    </>
                );
            } else {
                if (data.jobStatus === 0) {
                    return (
                        <>
                            <div className="btn-left">
                                <button onClick={() => openDetailAnDiscuss(data.jobAssignId, data.jobTitle, 'discuss', 'discuss')}>Thảo luận</button>
                            </div>
                            <div className="btn-right">
                                <button onClick={(e) => { submitJobs('remindJob', dataJob.jobAssignId); handleClick(e) }}>Nhắc nhở</button>
                            </div>
                        </>
                    );
                } else {
                    if (data.jobActive === 0) {
                        return (
                            <>
                                <div className="btn-left">
                                    <button onClick={(e) => { submitJobs('remindJob', dataJob.jobAssignId); handleClick(e) }}>Nhắc nhở</button>
                                </div>
                                <div className="btn-right">
                                    <button onClick={() => openDetailAnDiscuss(data.jobAssignId, data.jobTitle, 'discuss', 'discuss')}>Thảo luận</button>
                                </div>
                            </>
                        );
                    }
                }
            }
        }
    }

    function openModal() {
        setDisplayModal('block');
        console.log('modal show');
    }

    function closeModal() {
        setDisplayModal('none');
        console.log('modal hide');
    }

    function renderButtonModal(data, type) {
        console.log(type);
        if (type === 1) {
            if (data.jobActive === 1) {
                setDisplayComplete('none');
                setDisplayClose('none');
                setDisplayAccept('none');
                setDisplayRefuse('none');
                setDisplayDiscuss('block');
                setDisplayEdit('block');
                setDisplayReopen('block');
                setDisplayDelete('block');
                setDisplayRemind('none');
            } else {
                setDisplayComplete('none');
                setDisplayClose('block');
                setDisplayAccept('none');
                setDisplayRefuse('none');
                setDisplayDiscuss('block');
                setDisplayEdit('block');
                setDisplayReopen('none');
                setDisplayDelete('block');
                setDisplayRemind('block');
            }
        } else {
            if(data.jobPersonStatus === 1){
                setDisplayComplete('none');
                setDisplayClose('none');
                setDisplayAccept('none');
                setDisplayRefuse('none');
                setDisplayDiscuss('block');
                setDisplayEdit('none');
                setDisplayReopen('none');
                setDisplayDelete('none');
                setDisplayRemind('none');
            }else{
                if(data.isExpired === 1){
                    setDisplayComplete('block');
                    setDisplayClose('none');
                    setDisplayAccept('none');
                    setDisplayRefuse('none');
                    setDisplayDiscuss('block');
                    setDisplayEdit('none');
                    setDisplayReopen('none');
                    setDisplayDelete('none');
                    setDisplayRemind('none');
                }else{
                    if (data.jobPersonRecipientStatus === 0){
                        setDisplayComplete('block');
                        setDisplayClose('none');
                        setDisplayAccept('block');
                        setDisplayRefuse('block');
                        setDisplayDiscuss('block');
                        setDisplayEdit('none');
                        setDisplayReopen('none');
                        setDisplayDelete('none');
                        setDisplayRemind('none');
                    } else{
                        setDisplayComplete('block');
                        setDisplayClose('none');
                        setDisplayAccept('none');
                        setDisplayRefuse('none');
                        setDisplayDiscuss('block');
                        setDisplayEdit('none');
                        setDisplayReopen('none');
                        setDisplayDelete('none');
                        setDisplayRemind('none');
                    }
                }
            }


        }
    }

    function closeDetail() {
        console.log('close detail');
        window.location.assign('vconnect://back?ref=assignwork');
    }

    const handleClick = event => {
        event.currentTarget.disabled = true;
        console.log('btn click');
    }

    const handleHide = event => {
        event.currentTarget.style = 'display:none';
        console.log('btn hide');
    }

    return (
        <>
            <Toaster />
            <GridLoader
                color={'#B80001'}
                loading={loading}
                cssOverride={{
                    display: "block",
                    margin: "auto",
                    position: 'absolute',
                    top: '40vh',
                    left: 'calc(50vw - 28px)',
                }}
                height={35}
                size={15}
                width={4}
                radius={2}
                margin={2}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
            <div className='navbar'>
                <div className='nav-btn'>
                    {renderBackBtn()}
                </div>
                <div className='nav-title'>
                    {dataJob.jobTitle ? (
                        <p className='nav-title'>{dataJob.jobTitle}</p>
                    ) : (
                        <p className='nav-title'>Không có dữ liệu</p>
                    )}
                </div>
                <div className='nav-btn'>
                    <button onClick={() => openModal()}>
                        <img src="../../images/icon/more.png" alt="" />
                    </button>
                </div>
            </div>
            {show === true &&
                <>
                    <div className='detail-content'>
                        <div className='due-and-status'>
                            <div className='due-date-detail'>
                                <div>
                                    <img src="../../images/icon/due-detail.png" alt="" />
                                </div>
                                <div>
                                    <p className='title'>Thời hạn:</p>
                                    <p className='title-info'>{dueDate}</p>
                                </div>
                            </div>
                            <div className='status-detail'>
                                <div>
                                    <img src="../../images/icon/status-detail.png" alt="" />
                                </div>
                                <div>
                                    <p className='title'>Trạng thái:</p>
                                    <p className={statusClass}>{statusDesc}</p>
                                </div>
                            </div>
                        </div>
                        <div className='desc-detail'>
                            <textarea name="" id="" cols="30" rows="5" value={dataJob.jobDetails} readOnly></textarea>
                        </div>
                        <div className='mem-detail'>
                            <div className='job-label'>Giao cho ({countMember})
                            </div>
                            {listAssignedPerson.length > 0 &&
                                <div className="member-list">
                                    {listAssignedPerson.map((item, key) => {
                                        return (
                                            <div className="mem" key={key} id={`mem${key}`}>
                                                <img style={{ height: "50px", width: '50px' }} src={item.avatar ? (item.avatar === '' ? '../../images/icon/defaultUser.png' : item.avatar) : '../../images/icon/defaultUser.png'} alt="avt" />
                                                <p>{item.name}</p>
                                            </div>
                                        )
                                    })}
                                </div>
                            }
                        </div>
                        <div className='info-detail'>
                            <div style={{ 'textAlign': 'left' }} className='job-label'>Thông tin</div>
                            <div className='info-item'>
                                <ul>
                                    <li>Tạo bởi <span className='highlight'>{creator}</span> {renderDateInfo(dataJob.jobCreatedAt)}</li>
                                </ul>

                                {dataJob.personRecipientTime ?
                                    <ul>
                                        <li> <span className='highlight'>Bạn</span> đã nhận việc {renderDateInfo(dataJob.personRecipientTime)}</li>
                                    </ul>
                                    : ''}
                            </div>
                        </div>

                    </div>
                    <div className="footer">
                        <div className="button-task">
                            {renderButton(dataJob)}
                        </div>
                    </div>
                    <div className='modal' style={{ display: displayModal }}  >
                        <div className='bg' onClick={() => closeModal()}></div>
                        <div className='modal-content'>
                            <div className='modal-item' style={{ display: displayRemind }}>
                                <button onClick={(e) => { submitJobs('remindJob', dataJob.jobAssignId); handleClick(e) }}>
                                    <img src="../../images/icon/reopen.png" alt="" />
                                    <p>Nhắc nhở</p>
                                </button>
                            </div>
                            <div className='modal-item' style={{ display: displayComplete }}>
                                <button onClick={() => submitJobs('doneJob', dataJob.jobAssignId)}>
                                    <img src="../../images/icon/complete.png" alt="" />
                                    <p>Hoàn thành</p>
                                </button>
                            </div>
                            <div className='modal-item' style={{ display: displayClose }}>
                                <button onClick={(e) => { submitJobs('closeJob', dataJob.jobAssignId); handleHide(e) }}>
                                    <img src="../../images/icon/complete.png" alt="" />
                                    <p>Đóng việc</p>
                                </button>
                            </div>
                            <div className='modal-item' style={{ display: displayAccept }}>
                                <button onClick={() => submitJobs('recipientJob', dataJob.jobAssignId)}>
                                    <img src="../../images/icon/accept.png" alt="" />
                                    <p>Nhận thực hiện</p>
                                </button>
                            </div>
                            <div className='modal-item' style={{ display: displayRefuse }}>
                                <button onClick={() => submitJobs('deleteJob', dataJob.jobAssignId)}>
                                    <img src="../../images/icon/refuse.png" alt="" />
                                    <p>Từ chối công việc</p>
                                </button>
                            </div>
                            <div className='modal-item' style={{ display: displayDiscuss }}>
                                <button onClick={() => openDetailAnDiscuss(dataJob.jobAssignId, dataJob.jobTitle, 'discuss', 'discuss')}>
                                    <img src="../../images/icon/discuss.png" alt="" />
                                    <p>Thảo luận</p>
                                </button>
                            </div>
                            <div className='modal-item' style={{ display: displayEdit }}>
                                <button>
                                    <img src="../../images/icon/edit.png" alt="" />
                                    <Link style={{ textAlign: 'left', width: '100%' }} to={`/edit?id=${jobId}&mcapp=${mcapp}`}>Chỉnh sửa công việc</Link>
                                </button>
                            </div>
                            <div className='modal-item' style={{ display: displayReopen }}>
                                <button onClick={() => submitJobs('reopenJob', dataJob.jobAssignId)}>
                                    <img src="../../images/icon/reopen.png" alt="" />
                                    <p>Mở lại việc</p>
                                </button>
                            </div>
                            <div className='modal-item' style={{ display: displayDelete }}>
                                <button onClick={() => submitJobs('deleteJob', dataJob.jobAssignId)}>
                                    <img src="../../images/icon/delete.png" alt="" />
                                    <p>Xóa công việc</p>
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            }

        </>
    )
}
